import { dateInUtcOffset } from "./dateTime";

export function getDefaultDateTime(
  originUtcOffset: number = Math.abs(new Date().getTimezoneOffset() / 60),
): Date {
  const offsetDateTimeNow = dateInUtcOffset(new Date(), originUtcOffset);

  // Get time of origin location at the following day at 6am from now.
  const offsetDateTimeTomorrowMorning = new Date(offsetDateTimeNow);
  offsetDateTimeTomorrowMorning.setDate(
    offsetDateTimeTomorrowMorning.getDate() + 1,
  );
  offsetDateTimeTomorrowMorning.setHours(6, 0, 0, 0);
  return offsetDateTimeTomorrowMorning;
}
